/* eslint-disable jsx-quotes */

import React, { Component } from 'react';
import {
  List,
  Datagrid,
  TextField,
  Filter,
  Pagination
} from 'react-admin';
import PeriodInput from '../../lib/helper/PeriodInput';

export default class EinvoiceBusiness extends Component {
  componentWillMount() {
    localStorage.setItem('actionKey', 'getBusinessTransaction');
  }
  render () {
    const MoveFilter = (props, i) => (
      <Filter {...props}>
        <PeriodInput source='transactionDate' />
      </Filter>
    );
    return (
      <List filters={<MoveFilter />} pagination={<Pagination rowsPerPageOptions={[10, 50, 100]} />} {...this.props}>
        <Datagrid>
          <TextField source='transactionDate' />
          <TextField source='name' label='Organization Name' sortable={false} />
          <TextField source='email' label='Email' sortable={false} />
          <TextField source='vat_number' label='Vat' sortable={false} />
          <TextField source='city' label='City' sortable={false} />
          <TextField source='postal_code' label='Postal Code' sortable={false} />
          <TextField source='country' label='Country' sortable={false} />
          <TextField source='amount' label='Amount' sortable={false} />
          <TextField source='payment_status' label='Payment Status' sortable={false} />
          <TextField source='subscription_status' label='Subscription Status' sortable={false} />
          <TextField source='payment_type' label='Payment Type' sortable={false} />
        </Datagrid>
      </List>
    );
  }
}
